module.exports = __webpack_public_path__ + "static/media/38.c04d7004.png";